import { useEffect, useState } from 'react';

import { KeyboardKey } from '../../models/components.models';
import { BasicList, IBasicListProps } from '../BasicList/BasicList';
import { basicListStylesInput } from '../BasicList/BasicList.styles';
import { IItemProps, Item } from '../Item/Item';
import { itemStylesDropdown } from '../Item/Item.styles';
import { ITextFieldProps, TextField } from '../TextField/TextField';
import { textFieldStylesTextList } from '../TextField/TextField.styles';

export interface ITextListEditorProps {
  items?: string[];
  placeholder?: string;
  onChange: (items: string[]) => void;
  basicListProps?: IBasicListProps<{ [key: string]: any }>;
  textFieldProps?: ITextFieldProps;
  itemProps?: IItemProps<{ [key: string]: any }>;
}

export const TextListEditor = ({
  items = [],
  placeholder = 'Input with Enter',
  onChange,
  basicListProps,
  textFieldProps,
  itemProps,
}: ITextListEditorProps) => {
  const [text, setText] = useState('');
  const [texts, setTexts] = useState(items);
  useEffect(() => {
    setTexts(items);
  }, [items]);
  return (
    <BasicList
      styles={basicListStylesInput}
      idField="key"
      labelField="text"
      data={[{ key: '__input__', text: 'input' }, ...texts.map((d) => ({ key: d, text: d }))]}
      data-test="text-list-editor"
      horizontal
      itemRenderer={(d) =>
        d.key === '__input__' ? (
          <TextField
            styles={textFieldStylesTextList}
            name="text"
            placeholder={placeholder}
            value={text}
            onChange={(_e, text = '') => setText(text)}
            onKeyDown={(e) => {
              if (e.key === KeyboardKey.Enter) {
                if (text) {
                  if (!texts.includes(text)) {
                    texts.push(text);
                    setText('');
                    const items = [...texts];
                    setTexts(items);
                    onChange(items);
                  }
                }
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            {...textFieldProps}
          />
        ) : (
          <Item
            styles={itemStylesDropdown}
            hasClose
            data={d}
            idField="key"
            labelField="text"
            onClose={(d) => {
              const items = [...texts.filter((text) => text !== d.key)];
              setTexts(items);
              onChange(items);
            }}
            {...(itemProps as any)}
          />
        )
      }
      {...basicListProps}
    />
  );
};
